import React from "react";
import {
  Button,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { Add, ArrowDownward, ArrowUpward } from "@mui/icons-material";

export default function WorkflowStageList({
  stages,
  selectedKey,
  dispatch,
  criterion,
}) {
  return (
    <Paper sx={{ p: 2 }} aria-label="Accessible workflow stage list">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">Workflow stages</Typography>
        <Button
          startIcon={<Add />}
          onClick={() => dispatch({ type: "addStage", criterion })}
        >
          Add stage
        </Button>
      </Stack>
      <List>
        {stages.map((stage, index) => (
          <Stack key={stage.key} direction="row" alignItems="center">
            <ListItemButton
              selected={selectedKey === stage.key}
              onClick={() => dispatch({ type: "select", key: stage.key })}
            >
              <ListItemText
                primary={`${index + 1}. ${stage.name}`}
                secondary={`${stage.criterionCode} · ${stage.templates.length} emails${stage.isEntry ? " · Entry" : ""}${stage.isTerminal ? " · Terminal" : ""}`}
              />
            </ListItemButton>
            <Button
              aria-label={`Move ${stage.name} up`}
              disabled={!index}
              onClick={() =>
                dispatch({ type: "moveStage", key: stage.key, delta: -1 })
              }
            >
              <ArrowUpward />
            </Button>
            <Button
              aria-label={`Move ${stage.name} down`}
              disabled={index === stages.length - 1}
              onClick={() =>
                dispatch({ type: "moveStage", key: stage.key, delta: 1 })
              }
            >
              <ArrowDownward />
            </Button>
          </Stack>
        ))}
      </List>
    </Paper>
  );
}
